var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.413 8.675a6.047 6.047 0 11-12.094 0 6.047 6.047 0 0112.094 0zm1.586 0a7.633 7.633 0 01-9.905 7.29l-.014.024-3.778 6.36a1.248 1.248 0 01-1.693.443 1.211 1.211 0 01-.437-1.673l3.718-6.26a7.633 7.633 0 1112.108-6.184z",
    fill: "currentColor"
  })));
}
export default SvgTruth;